import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiRequest } from "../_helpers/apiConfig";
import moment from "moment/moment";

export const dashboardCardCounts = createAsyncThunk(
  "admin/getDashboardCardCounts",
  async (filters) => {
    const response = await apiRequest(
      "POST",
      "/v1/admin/getDashboardCardCounts",
      filters,
    );
    return response;
  },
);
export const dashboardOverviewKPIs = createAsyncThunk(
  "admin/getDashboardOverviewKPIs",
  async (filters) => {
    const response = await apiRequest(
      "POST",
      "/v1/admin/getDashboardOverviewKPIs",
      filters,
    );
    return response;
  },
);
export const getGraphData = createAsyncThunk(
  "adminApi/graphApi",
  async (filters) => {
    const response = await apiRequest("POST", "/v1/adminApi/graphApi", filters);
    return response;
  },
);
export const revenueOverviewGraph = createAsyncThunk(
  "adminApi/revenueOverviewGraph",
  async (filters) => {
    const response = await apiRequest(
      "POST",
      "/v1/adminApi/revenueOverviewGraph",
      filters,
    );
    return response;
  },
);
export const getTopExperts = createAsyncThunk(
  "admin/getTopExperts",
  async (filters) => {
    const response = await apiRequest(
      "POST",
      "/v1/admin/getTopExperts",
      filters,
    );
    return response;
  },
);
export const getRecentPayout = createAsyncThunk(
  "admin/getRecentPayout",
  async (filters) => {
    const response = await apiRequest(
      "POST",
      "/v1/admin/getRecentPayout",
      filters,
    );
    return response;
  },
);
export const revenueByType = createAsyncThunk(
  "adminApi/revenueByType",
  async (filters) => {
    const response = await apiRequest(
      "POST",
      "/v1/adminApi/revenueByType",
      filters,
    );
    return response;
  },
);
export const getTopCourses = createAsyncThunk(
  "admin/getTopCourses",
  async (filters) => {
    const response = await apiRequest(
      "POST",
      "/v1/admin/getTopCourses",
      filters,
    );
    return response;
  },
);
export const revenueAndTransactionStats = createAsyncThunk(
  "adminApi/revenueAndTransactionStats",
  async (filters) => {
    const response = await apiRequest(
      "POST",
      "/v1/adminApi/revenueAndTransactionStats",
      filters,
    );
    return response;
  },
);
export const recentTransactions = createAsyncThunk(
  "adminApi/recentTransactions",
  async (filters) => {
    const response = await apiRequest(
      "POST",
      "/v1/adminApi/recentTransactions",
      filters,
    );
    return response;
  },
);
export const recentFailedPendingTransactions = createAsyncThunk(
  "adminApi/recentFailedPendingTransactions",
  async (filters) => {
    const response = await apiRequest(
      "POST",
      "/v1/adminApi/recentTransactions",
      filters,
    );
    return response;
  },
);
export const sessionsOverview = createAsyncThunk(
  "adminApi/sessionsOverview",
  async (filters) => {
    const response = await apiRequest(
      "POST",
      "/v1/adminApi/sessionsOverview",
      filters,
    );
    return response;
  },
);
export const subscriptionsOverview = createAsyncThunk(
  "adminApi/subscriptionsOverview",
  async (filters) => {
    const response = await apiRequest(
      "POST",
      "/v1/adminApi/subscriptionsOverview",
      filters,
    );
    return response;
  },
);

export const latestStudentSignUp = createAsyncThunk(
  "user/listAdmin",
  async (filters) => {
    const response = await apiRequest("POST", "/v1/user/listAdmin", filters);
    return response;
  },
);

export const getTopCoursePerformanceList = createAsyncThunk(
  "course/listAdmin",
  async (filters) => {
    const response = await apiRequest("POST", "/v1/course/listAdmin", filters);
    return response;
  },
);

const dashboardslice = createSlice({
  name: "dashboard",
  initialState: {
    cardCounts: {},
    latestSignUp: [],
    total: null,
    loading: false,
    error: null,
    graphLoading: false,
    overviewKPIs: {},
    overviewKPIsLoading: false,
    overviewKPIsError: null,
    revenueOverview: {},
    revenueOverviewLoading: false,
    revenueOverviewError: null,
    topExperts: [],
    topExpertsLoading: false,
    topExpertsError: null,
    revenueByType: {},
    revenueByTypeLoading: false,
    revenueByTypeError: null,
    revenueAndTransactionStats: {},
    revenueAndTransactionStatsLoading: false,
    revenueAndTransactionStatsError: null,
    recentTransactions: [],
    recentTransactionsLoading: false,
    recentTransactionsError: null,
    recentFailedPendingTransactions: [],
    recentFailedPendingTransactionsLoading: false,
    recentFailedPendingTransactionsError: null,
    topCourses: [],
    topCoursesLoading: false,
    topCoursesError: null,
    sessionsOverview: {},
    sessionsOverviewLoading: false,
    sessionsOverviewError: null,
    subscriptionsOverview: [],
    subscriptionsOverviewLoading: false,
    subscriptionsOverviewError: null,
    recentPayouts: [],
    recentPayoutsLoading: false,
    recentPayoutsError: null,
    dashboardFilter: {
      startDate: moment().subtract(89, "days").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      days: 90,
    },
  },
  reducers: {
    setDashboardFilter: (state, action) => {
      state.dashboardFilter = action.payload;
    },
    clearDashboardFilter: (state) => {
      state.dashboardFilter = {
        startDate: moment().subtract(89, "days").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        days: 90,
      };
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(dashboardCardCounts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(dashboardCardCounts.fulfilled, (state, action) => {
        state.loading = false;
        state.cardCounts = action.payload.data;
      })
      .addCase(dashboardCardCounts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(dashboardOverviewKPIs.pending, (state) => {
        state.overviewKPIsLoading = true;
        state.overviewKPIsError = null;
      })
      .addCase(dashboardOverviewKPIs.fulfilled, (state, action) => {
        state.overviewKPIsLoading = false;
        state.overviewKPIs = action.payload.data;
      })
      .addCase(dashboardOverviewKPIs.rejected, (state, action) => {
        state.overviewKPIsLoading = false;
        state.overviewKPIsError = action.error.message;
      })
      .addCase(getGraphData.pending, (state) => {
        state.graphLoading = true;
        state.graphError = null;
      })
      .addCase(getGraphData.fulfilled, (state, action) => {
        state.graphLoading = false;
        state.graphData = action.payload.data;
      })
      .addCase(getGraphData.rejected, (state, action) => {
        state.graphLoading = false;
        state.graphError = action.error.message;
      })
      .addCase(revenueOverviewGraph.pending, (state) => {
        state.revenueOverviewLoading = true;
        state.revenueOverviewError = null;
      })
      .addCase(revenueOverviewGraph.fulfilled, (state, action) => {
        state.revenueOverviewLoading = false;
        state.revenueOverview = action.payload.data;
      })
      .addCase(revenueOverviewGraph.rejected, (state, action) => {
        state.revenueOverviewLoading = false;
        state.revenueOverviewError = action.error.message;
      })
      .addCase(getTopExperts.pending, (state) => {
        state.topExpertsLoading = true;
        state.topExpertsError = null;
      })
      .addCase(getTopExperts.fulfilled, (state, action) => {
        state.topExpertsLoading = false;
        state.topExperts = action.payload.data;
      })
      .addCase(getTopExperts.rejected, (state, action) => {
        state.topExpertsLoading = false;
        state.topExpertsError = action.error.message;
      })
      .addCase(revenueByType.pending, (state) => {
        state.revenueByTypeLoading = true;
        state.revenueByTypeError = null;
      })
      .addCase(revenueByType.fulfilled, (state, action) => {
        state.revenueByTypeLoading = false;
        state.revenueByType = action.payload.data;
      })
      .addCase(revenueByType.rejected, (state, action) => {
        state.revenueByTypeLoading = false;
        state.revenueByTypeError = action.error.message;
      })
      .addCase(getTopCourses.pending, (state) => {
        state.topCoursesLoading = true;
        state.topCoursesError = null;
      })
      .addCase(getTopCourses.fulfilled, (state, action) => {
        state.topCoursesLoading = false;
        state.topCourses = action.payload.data;
      })
      .addCase(getTopCourses.rejected, (state, action) => {
        state.topCoursesLoading = false;
        state.topCoursesError = action.error.message;
      })
      .addCase(revenueAndTransactionStats.pending, (state) => {
        state.revenueAndTransactionStatsLoading = true;
        state.revenueAndTransactionStatsError = null;
      })
      .addCase(revenueAndTransactionStats.fulfilled, (state, action) => {
        state.revenueAndTransactionStatsLoading = false;
        state.revenueAndTransactionStats = action.payload.data;
      })
      .addCase(revenueAndTransactionStats.rejected, (state, action) => {
        state.revenueAndTransactionStatsLoading = false;
        state.revenueAndTransactionStatsError = action.error.message;
      })
      .addCase(recentTransactions.pending, (state) => {
        state.recentTransactionsLoading = true;
        state.recentTransactionsError = null;
      })
      .addCase(recentTransactions.fulfilled, (state, action) => {
        state.recentTransactionsLoading = false;
        state.recentTransactions = action.payload.data;
      })
      .addCase(recentTransactions.rejected, (state, action) => {
        state.recentTransactionsLoading = false;
        state.recentTransactionsError = action.error.message;
      })
      .addCase(recentFailedPendingTransactions.pending, (state) => {
        state.recentFailedPendingTransactionsLoading = true;
        state.recentFailedPendingTransactionsError = null;
      })
      .addCase(recentFailedPendingTransactions.fulfilled, (state, action) => {
        state.recentFailedPendingTransactionsLoading = false;
        state.recentFailedPendingTransactions = action.payload.data;
      })
      .addCase(recentFailedPendingTransactions.rejected, (state, action) => {
        state.recentFailedPendingTransactionsLoading = false;
        state.recentFailedPendingTransactionsError = action.error.message;
      })
      .addCase(sessionsOverview.pending, (state) => {
        state.sessionsOverviewLoading = true;
        state.sessionsOverviewError = null;
      })
      .addCase(sessionsOverview.fulfilled, (state, action) => {
        state.sessionsOverviewLoading = false;
        state.sessionsOverview = action.payload.data;
      })
      .addCase(sessionsOverview.rejected, (state, action) => {
        state.sessionsOverviewLoading = false;
        state.sessionsOverviewError = action.error.message;
      })
      .addCase(subscriptionsOverview.pending, (state) => {
        state.subscriptionsOverviewLoading = true;
        state.subscriptionsOverviewError = null;
      })
      .addCase(subscriptionsOverview.fulfilled, (state, action) => {
        state.subscriptionsOverviewLoading = false;
        state.subscriptionsOverview = action.payload.data;
      })
      .addCase(subscriptionsOverview.rejected, (state, action) => {
        state.subscriptionsOverviewLoading = false;
        state.subscriptionsOverviewError = action.error.message;
      })
      .addCase(getRecentPayout.pending, (state) => {
        state.recentPayoutsLoading = true;
        state.recentPayoutsError = null;
      })
      .addCase(getRecentPayout.fulfilled, (state, action) => {
        state.recentPayoutsLoading = false;
        state.recentPayouts = action.payload.data;
      })
      .addCase(getRecentPayout.rejected, (state, action) => {
        state.recentPayoutsLoading = false;
        state.recentPayoutsError = action.error.message;
      })
      .addCase(getTopCoursePerformanceList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTopCoursePerformanceList.fulfilled, (state, action) => {
        state.loading = false;
        state.courseList = action.payload.data;
      })
      .addCase(getTopCoursePerformanceList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(latestStudentSignUp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(latestStudentSignUp.fulfilled, (state, action) => {
        state.loading = false;
        state.latestSignUp = action.payload.data.list;
      })
      .addCase(latestStudentSignUp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});
export const { setDashboardFilter, clearDashboardFilter } = dashboardslice.actions;


export default dashboardslice.reducer;
